module.exports = __webpack_public_path__ + "img/box1.ff1b2a76.png";